__turbopack_context__.v({
  "barIcon": "iA41aW_barIcon",
  "caret": "iA41aW_caret",
  "contentsBtn": "iA41aW_contentsBtn",
  "crumbCurrent": "iA41aW_crumbCurrent",
  "crumbIcon": "iA41aW_crumbIcon",
  "crumbLink": "iA41aW_crumbLink",
  "crumbText": "iA41aW_crumbText",
  "crumbs": "iA41aW_crumbs",
  "explainerSheetFadeIn": "iA41aW_explainerSheetFadeIn",
  "explainerSheetSlideUp": "iA41aW_explainerSheetSlideUp",
  "footerRule": "iA41aW_footerRule",
  "layout": "iA41aW_layout",
  "layoutInner": "iA41aW_layoutInner",
  "main": "iA41aW_main",
  "mobileBar": "iA41aW_mobileBar",
  "mobileSearch": "iA41aW_mobileSearch",
  "page": "iA41aW_page",
  "sep": "iA41aW_sep",
  "sheet": "iA41aW_sheet",
  "sheetBackdrop": "iA41aW_sheetBackdrop",
  "sheetBody": "iA41aW_sheetBody",
  "sheetGrip": "iA41aW_sheetGrip",
  "sidebarColumn": "iA41aW_sidebarColumn",
  "sidebarFloat": "iA41aW_sidebarFloat",
  "tocColumn": "iA41aW_tocColumn",
  "tocFloat": "iA41aW_tocFloat",
});
